import React from "react";
import ReactDOM from "react-dom/client";
//
import "rc-slider/assets/index.css";
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import { Auth0Provider } from '@auth0/auth0-react';
//
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// import dotenv from 'dotenv';
// dotenv.config();
// import AWS from 'aws-sdk';

// const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
// const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
// const region = process.env.REACT_APP_AWS_REGION;
// const bucket = process.env.REACT_APP_BUCKETNAME;


// AWS.config.update({
//     accessKeyId: accessKeyId,
//     secretAccessKey: secretAccessKey,
//     region: region
// });

// const s3 = new AWS.S3();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Auth0Provider
    domain="paradise-living.us.auth0.com"
    clientId="xgnllnhYBTxtIYQmAjTCEOj3ZL3aFycA"
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
     <App />
  </Auth0Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
